import React, { Component } from 'react';
import { Router, Route, Redirect, Switch, HashRouter } from "react-router-dom";
import logger from './services/errorlogger';

import PluginHeader from './components/PluginHeader/PluginHeader';
import PluginFooter from './components/PluginFooter/PluginFooter';
import DemoSidebar from './components/DemoSidebar/DemoSidebar';

import OverviewPage from './pages/Overview/OverviewPage';
import SettingsPage from './pages/Settings/SettingsPage';
import HelpPage from './pages/Help/HelpPage';

import { StateProvider } from './state/StateProvider';

import './App.css';

const isProduction = process.env.NODE_ENV === 'production';

logger.init();

class App extends Component {
    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                {/* <DemoSidebar /> */}
                <div style={{ width: 1280, minWidth: 920, marginLeft: 30 }}>
                    <StateProvider {...this.props}>
                        <HashRouter hastype="noslash">
                            <PluginHeader />
                            <Route path="/report/" component={OverviewPage} />
                            <Route path="/settings/" component={SettingsPage} />
                            <Route path="/help/" component={HelpPage} />
                        
                            <Redirect to="/report/" />
                        </HashRouter>
                        <PluginFooter />
                    </StateProvider>
                </div>
            </div>
        );
    }
}

export default App;
